<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-stop-circle', fontSet: 'fad'}"
	[headerText]="T.STOP_RECORDING_DIALOG_STOP_RECORDING | translate"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<div class="text">
			<h3 class="mat-h2 nomargin nopadding">
				{{ T.STOP_RECORDING_DIALOG_REALLY | translate }}
			</h3>
			<h3 class="mat-h3">
				{{ T.STOP_RECORDING_DIALOG_FINISH_AUTOMATICALLY | translate }}
			</h3>
			<span class="countdown">{{ T.STOP_RECORDING_DIALOG_SEC | translate: {duration: countDown} }}</span>
		</div>
	</ng-container>

	<ng-container actions>
		<button (click)="deleteAndAbortClicked()" color="warn" mat-button style="margin-right: auto">
			<mat-icon fontIcon="fa-trash-alt" fontSet="fad" inline style="font-size: 1.4em; margin-right: 10px" />
			{{ T.RECORDING_DELETE_FILES_AND_ABORT | translate }}
		</button>

		<sim-button
			(onClick)="close({action: 'ok', followUpAction: 'cancel'})"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-times'}"
			color="warn"
			style="margin-right: 15px"
			[label]="T.BUTTON_CANCEL"
		/>

		<sim-button
			(onClick)="close({action: 'ok', followUpAction: 'stop'})"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			color="accent"
			[label]="T.BUTTON_I_M_DONE"
		/>
	</ng-container>
</sim-basic-material-dialog>
